import { Text } from 'app/design/primitives/text';
import { createTheme as createDSTheme } from 'app/shopify';
import { ActivityIndicator, Pressable, StyleSheet } from 'react-native';

const theme = createDSTheme();

export function InterestTagChip({
  label,
  isSelected,
  isPending,
  onPress,
}: {
  label: string;
  isSelected: boolean;
  isPending: boolean;
  onPress: () => void;
}) {
  return (
    <Pressable
      accessibilityLabel={label}
      accessibilityRole="button"
      accessibilityState={{ selected: isSelected, busy: isPending }}
      onPress={onPress}
      style={({ pressed }) => ({
        flexDirection: 'row',
        alignItems: 'center',
        gap: theme.spacing['spacing.general.x1'],
        paddingHorizontal: theme.spacing['spacing.general.x3'],
        paddingVertical: theme.spacing['spacing.general.x1'] + 2,
        borderRadius: theme.borderRadii['radius.full'],
        opacity: isPending ? 0.55 : pressed ? 0.75 : 1,
        backgroundColor: isSelected
          ? theme.colors['surface.inverse.default']
          : theme.colors['surface.tertiary-neutral'],
        borderWidth: isSelected ? 0 : 1,
        borderColor: theme.colors['surface.inverse.tertiary-neutral'],
      })}
    >
      {isPending ? (
        <ActivityIndicator
          color={isSelected ? '#FFFFFF' : theme.colors['text.secondary']}
          size="small"
          style={styles.chipSpinner}
        />
      ) : isSelected ? (
        <Text style={styles.chipCheck}>✓</Text>
      ) : null}
      <Text
        fontSize={14}
        fontWeight={isSelected ? '600' : '400'}
        style={isSelected ? styles.chipLabelSelected : undefined}
      >
        {label}
      </Text>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  chipSpinner: {
    width: 14,
    height: 14,
  },
  chipCheck: {
    color: '#FFFFFF',
    fontSize: 13,
    fontWeight: '600',
  },
  chipLabelSelected: {
    color: '#FFFFFF',
  },
});
